import { FC } from 'react'
import styles from './styles.module.scss'
import cx from 'classnames'
import { CmsResponsiveImage } from '../Sections/PageHero'
import { DynamicImage } from '../DynamicImage'

export interface IdentImageTitleProps {
  Tag: 'h1' | 'h2' | 'h3' | 'h4'
  image: CmsResponsiveImage
  title: string
  imageAlignment: 'right' | 'left'
}

export const IdentImageTitle: FC<IdentImageTitleProps> = ({
  Tag,
  title,
  image,
  imageAlignment,
}) => {
  return (
    <div className={styles.identImageTitle}>
      <Tag>{title}</Tag>
      <DynamicImage
        className={cx(styles.titleIdentImage, styles[imageAlignment])}
        alt={image.fields.title || ''}
        image={image}
        width={image.fields.file.details.image.width}
        height={image.fields.file.details.image.height}
        sizes="280px"
      />
    </div>
  )
}
